import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../";

import { HTMLInputProps } from "@blueprintjs/core";

import { MPDIcon } from "src/mpd-library";

import "./styles.css";

export const SearchInput: React.SFC<HTMLInputProps> = props => {
  const { className, ...newProps } = props;

  const classes = classNames(myClasses.SEARCH_INPUT, className);

  return (
    <div className={classes}>
      <MPDIcon name="list-view--header--search" />
      <input type="search" {...newProps} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/search-input/search-input.tsx